var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "circle_warning_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 26960",
    fill: "currentColor",
    d: "M0 0h32v32H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 39225",
    clipPath: "url(#circle_warning_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17368",
    d: "M16 3A13 13 0 113 16 13.015 13.015 0 0116 3m0-3a16 16 0 1016 16A16 16 0 0016 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17369",
    d: "M16 20.577a1.5 1.5 0 01-1.5-1.49V8.49a1.5 1.5 0 013 0v10.6a1.5 1.5 0 01-1.5 1.49"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17370",
    d: "M16 22a1.5 1.5 0 11-1.5 1.5A1.5 1.5 0 0116 22"
  }))));
}
export default SvgCircleWarning;